<template>
  <div>
    <b-modal
      id="modal-delete-gaji"
      size="md"
      centered
      title="Perhatian"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <p>{{ $store.state.form.delete_message }}</p>

      <template #modal-footer>
        <b-button variant="primary" @click="hapus()">
          {{ $store.state.form.ya }}
        </b-button>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-delete-gaji')"
        >
          {{ $store.state.form.tidak }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "modalDelete",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Hapus",
    };
  },
  methods: {
    hapus() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.$axios
        .post("masterGaji/delete", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS DATA MASTER TUNJANGAN TETAP",
              showing: true,
            });
            vm.$bvModal.hide("modal-delete-gaji");
          } else {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err
          vm.button = "Hapus";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
